import { render, staticRenderFns } from "./FullTxtArtAnalysisResultWorkBench.vue?vue&type=template&id=2bbadca9&scoped=true"
import script from "./FullTxtArtAnalysisResultWorkBench.vue?vue&type=script&lang=js"
export * from "./FullTxtArtAnalysisResultWorkBench.vue?vue&type=script&lang=js"
import style0 from "./FullTxtArtAnalysisResultWorkBench.vue?vue&type=style&index=0&id=2bbadca9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbadca9",
  null
  
)

export default component.exports